import { render } from "./ProductToDimension.vue?vue&type=template&id=50a1fc8d&ts=true"
import script from "./ProductToDimension.vue?vue&type=script&lang=ts"
export * from "./ProductToDimension.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__